export class StartBusyMessage {
	static readonly type = '[App State Action] Start Busy Message';
	constructor(public message: string) {}
}

export class EndBusyMessage {
	static readonly type = '[App State Action] End Busy Message';
}
